module.exports = __webpack_public_path__ + "img/24.cd81c0f3.jpeg";